import Reflux from "reflux";

export default Reflux.createActions([
  "openAddShelfTextbox",
  "closeAddShelfTextbox",
  "updateShelfNameFilter",
  "updateShelves",
]);
